<template>
    <v-container>
        <v-layout>
            <v-flex md11 justify-center text-xs-center offset-md1>
                <h1 class="font-weight-light">รายชื่อผู้มีสิทธิ์เข้าร่วมกิจกรรม</h1>
                <h1 class="font-weight-light">{{eventName}}</h1>
            </v-flex>
            <v-flex md2>
                <v-btn top right @click="routeToSearchPage" dark color="#97c763">กลับ</v-btn>
            </v-flex>
        </v-layout>

        <v-layout justify-center>
            <v-flex xs12 md11 text-xs-center>
                <input type="text"  class="telBox" v-model="search" placeholder="ค้นหา">
                 <v-dialog
                    v-model="dialog"
                    hide-overlay
                    persistent
                    width="300"
                    >
                    <v-card
                        color="#97c763"
                        dark
                    >
                        <v-card-text>
                        กำลังโหลด
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                        </v-card-text>
                    </v-card>
                    </v-dialog>
                    
                 <div>
                    <v-tabs
                    v-model="active"
                    color="#97c763"
                    dark
                    slider-color="white"
                    >
                    <v-tab
                        v-for="(n, index) in status"
                        :key="index"
                        ripple
                        @click="filterStatus(index)"
                    >
                         {{ n }}
                    </v-tab>
                    <v-tab-item
                        v-for="n in 4"
                        :key="n"
                    >
                        <v-card flat>
                        <v-data-table
                            :headers="userData.headers"
                            :items="userData.items"
                            class="elevation-1"
                            :rows-per-page-items="rows_per_page"
                            loading="true"
                            :search="search"
                        >
                            <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.index + 1 }}</td>
                            <td class="text-xs-center">{{ props.item.fullName }}</td>
                            <td class="text-xs-center">{{ props.item.age }}</td>
                            <td class="text-xs-center">{{ props.item.tel }}</td>
                            <td class="text-xs-center">{{ props.item.round }}</td>
                            <td class="text-xs-center">{{ props.item.result }}</td>
                            <!-- <td class="text-xs-center"><v-btn color="#97c763" dark @click="routeToUserDetail(props.item.key)">รายละเอียด</v-btn></td> -->
                            </template>
                        </v-data-table>
                        </v-card>
                    </v-tab-item>
                    </v-tabs>
                </div><br><br><br>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import firebase from 'firebase'

export default {
     data () {
      return {
        active: null,
        status: ['รอยืนยัน', 'ยืนยันแล้ว', 'ยกเลิก', 'ทั้งหมด'],
        userData: {
            headers: [
                { text: '#', align: 'center', sortable: false,  width: '3%' },
                { text: 'ชื่อ - นามสกุล', align: 'center', sortable: false, value: 'fullName'},
                { text: 'อายุ', align: 'center', sortable: false, value: 'age'},
                { text: 'เบอร์โทร', align: 'center', sortable: false, value: 'tel' },
                { text: 'รุ่น', align: 'center', sortable: false, value: 'round' },
                { text: 'สถานะ', align: 'center', sortable: false, value:'interviewStatus' },
                // { text: 'รายละเอียด', align: 'center', sortable: false }
            ],
            items: [],
        },
        rows_per_page: [{text: 'All', value: -1}, 5, 10, 25],
        allData: [],
        search: '',
        dialog: true,
        eventName: ''
      }
    },
    methods: {
        routeToUserDetail(id) {
            // this.$router.push(`/homepro/` + id)
            var win = window.open('/homepro/' + id, '_blank');
            win.focus();
            
        },
        
        filterStatus(status) {
            if(status === 0) {
                this.userData.items = this.allData.filter(e => {
                    return e.status === null
                })
            } else if(status === 1) {
                this.userData.items = this.allData.filter(e => {
                    return e.status === true
                })
            } else if(status === 2) {
                this.userData.items = this.allData.filter(e => {
                    return e.status === false
                })
            } else {
                this.userData.items = this.allData
            }
        },
        routeToHomeproPage() {
            this.$router.push(`/homepro`)
        },
        routeToSearchPage() {
            this.$router.push(`/`)
        },
    },
    created() {
        console.log(this.$route.params.id)
    },
    mounted () {
        let confirm = 0
        let cancel = 0
        let wait = 0
        let all = 0

        const db2 = firebase.database().ref('/all/'+this.$route.params.id+'/text').once('value', (data) => {
            this.eventName = data.child('name').val()

        })

        const db = firebase.database().ref('/all/'+this.$route.params.id+'/data').once('value', (data) => {
            this.dialog = true
            data.forEach(e => {
                let user = e.child('tel').val()
                // console.log(user)
                let tempShift = ''
                if (e.child('canShiftWork').val() === 0) {
                    tempShift = 'ไม่ได้'
                } else {
                    tempShift = 'ได้'
                }

                let tempExp = ''
                if (e.child('hasExperience').val() === 0) {
                    tempExp = 'ไม่เคย'
                } else {
                    tempExp = 'เคย'
                }

                let interviewTime = ''
                let tempInterview = e.child('interviewTime').val()
                if (e.child('interviewTime').val() === 'รอบเช้า') {
                    interviewTime = 'วันที่ 14 ธ.ค. 2561 รอบเช้า เวลา 10.00-12.00 น.'
                } else if (e.child('interviewTime').val() === 'รอบบ่าย') {
                    interviewTime = 'วันที่ 14 ธ.ค. 2561 รอบบ่าย เวลา 13.00-16.00 น.'
                }

                this.resultInterview = e.child('result').val()
                let result = ''


                let interviewStatus = e.child('status').val()
                if (interviewStatus === true) {
                    result = 'ยืนยันแล้ว'
                    confirm++
                } else if (interviewStatus === false) {
                    result = 'ยกเลิก'
                    cancel++
                } else if (interviewStatus === null) {
                    result = 'รอยืนยัน'
                    wait++
                }
                
                let lastname = e.child('lastName').val()
                if (lastname === null) {
                    lastname = ""
                }

                let temp = {
                    name: e.child('name').val(),
                    lastName: lastname,
                    tel: e.child('tel').val(),
                    fullName: e.child('name').val() + ' '+ lastname,
                    age: e.child('age').val(),
                    email: e.child('email').val(),
                    address: e.child('address').val(),
                    position: e.child('position').val(),
                    experience: e.child('experience').val(),
                    hasExp: tempExp,
                    canShiftWork: tempShift,
                    health: e.child('health').val(),
                    disease: e.child('disease').val(),
                    potential: e.child('potential').val(),
                    education: e.child('education').val(),
                    other: e.child('other').val(),
                    branch: e.child('Branch').val(),
                    productBought: e.child('productBought').val(),
                    carreerHistory: e.child('careerHistory').val(),
                    inspiration: e.child('inspiration').val(),
                    round: e.child('round').val(),
                    interviewTime: interviewTime,
                    key: e.key,
                    comment: e.child('comment').val(),
                    result: result,
                    status: e.child('status').val(),
                    interviewStatus: interviewStatus,
                    tempInterview: tempInterview
                }
                // this.userData.items.push(temp)
                this.allData.push(temp)
                all++
            })
            this.dialog = false
            this.status[0] = 'รอยืนยัน (' + wait +')'
            this.status[1] = 'ยืนยันแล้ว (' + confirm +')'
            this.status[2] = 'ยกเลิก (' + cancel +')'
            this.status[3] = 'ทั้งหมด (' + all +')'
        }).then( e => {
            this.filterStatus(0)
        })
    },
}
</script>

<style>
input[text] { 
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  text-align: center;
  background-color: #f8f8f8;
  font-size: 18px;
  border-radius: 4px;
  border: 2px solid #ccc;
}
</style>

